import { memo, useCallback, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { AppBar, Toolbar } from '@mui/material';
import {
    Fade,
    Grid,
    FormControl,
    TextField,
    Box,
    Menu,
    MenuItem
} from '@mui/material';
import Controls from '../../components/controls/Controls'
import { ReactComponent as AddSquareIcon } from "../../assets/icons/icon-add-square.svg"
import { ReactComponent as MoreIcon } from "../../assets/icons/icon-more.svg";
import { ReactComponent as RightAngleIcon } from "../../assets/icons/icon-angle-right-small-secondary.svg";
import { ReactComponent as TitleEditIcon } from "../../assets/icons/icon-report-title-edit.svg";
import { ReactComponent as CopyAsNewIcon } from "../../assets/icons/icon-report-copy-as-new-primary.svg";
import { ReactComponent as ExportIcon } from "../../assets/icons/icon-report-export-primary.svg";
import { ReactComponent as AddNewReportIcon } from "../../assets/icons/icon-report-new.svg";
import { ReactComponent as DropdownIcon } from "../../assets/icons/icon-angle-down.svg";
import ExportReactCSV from "../../utils/ExportCSV";
import { initXLSXExport } from "../../utils/ExportXLSX";

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    title: {
        color: '#202124',
        fontSize: '22px',
    },
    subtitle: {
        fontSize: '14px',
        color: '#202124',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    headingButton: {
        display: 'block',
        width: '100%',
    },
    headingIcon: {
        display: 'flex',
        '&:hover': {
            background: 'none',
        },
    },
    reportHeader: {
        background: 'transparent',
        boxShadow: 'none',
        // borderBottom: '1px solid #DEDEDE',
    },
    button: {
        color: '#202124',
        fontWeight: 'normal',
        '&:hover': {
            background: 'none',
        },
        marginLeft: 0,
        paddingLeft: 0,
    },
    headingButtonWrap: {
        width: '90%',
        float: 'right',
        padding: '0 1rem',
        '&:hover': {
            backgroundColor: '#f45e29',
        },
        ['@media (max-width:1700px)']: {
            padding: '0 0.5rem',
            width: '95%',
            lineHeight: '16px',
            textAlign: 'center',
        },
        ['@media (max-width:1400px)']: {
            padding: '0.2rem 0.5rem',
            width: '100%',
            textAlign: 'center',
            lineHeight: '16px',
        },
        ['@media (max-width: 1199px)']: {
            float: 'left',
        }
    },
    headerButtons: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start'
        },
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}));
const ReportHeaderNew = ({ onOpenSidebar, handleSaveAsPoup, handleDeleteReportPopup, onOpenCalculatedFields }) => {
    const classes = useStyles();
    const [addMenuEl, setAddMenuEl] = useState(null);
    const [moreMenuEl, setMoreMenuEl] = useState(null);
    const [moreExportMenuEl, setMoreExportMenuEl] = useState(null);
    const [isReportTitleInEditMode, SetIsReportTitleInEditMode] = useState(false);

    const handleTitleEditClick = () => {
        SetIsReportTitleInEditMode(true);
    }


    const handleAddMenuHover = useCallback((event) => {
        if (addMenuEl !== event.currentTarget) {
            setAddMenuEl(event.currentTarget);
        }
    })

    const handleAddMenuClose = useCallback(() => {
        setAddMenuEl(null);
    })

    const handleMoreMenuHover = useCallback((event) => {
        if (moreMenuEl !== event.currentTarget) {
            setMoreMenuEl(event.currentTarget);
        }
    })

    const handleMoreMenuClose = useCallback(() => {
        setMoreMenuEl(null);
    })

    const handleMoreExportMenuClick = useCallback((event) => {
        if (moreExportMenuEl !== event.currentTarget) {
            setMoreExportMenuEl(event.currentTarget);
        }
    })

    const handleExport = useCallback((exportType) => {
        setMoreExportMenuEl(null);
        setMoreMenuEl(null);
    })

    return <div className={classes.grow}>
        <AppBar className={classes.reportHeader} position="relative">
            <Toolbar className="re-edit-header-wrapper" >
                <Grid container className="report-new-header-container" justifyContent="space-between"  >
                    <Grid container item alignItems="start" justifyContent="center" direction="column" 
                        sm={12} md={12} lg={6} order={{ lg: 1, md: 1, sm: 1, xs: 1 }} >
                        {
                            isReportTitleInEditMode
                                ?   <>
                                        <FormControl sx={{ marginBottom: '1rem' }}>
                                            <TextField placeholder="Report Name" size="small" variant="standard" 
                                                className="re-edit-header-input main-title"
                                                inputRef={input => input && input.focus()} autoComplete={'off'}  />
                                        </FormControl>
                                        <FormControl fullWidth className={classes.margin}>
                                            <TextField placeholder="Description about the report." size="small" 
                                                variant="standard" className="re-edit-header-input sub-title" 
                                                    autoComplete={'off'} />
                                        </FormControl>
                                    </>
                                :   <>
                                        <Box className="re-edit-header-in-edit-mode">
                                            <Box className="re-edit-header-title"><span>Report Name</span> <TitleEditIcon onClick={() => SetIsReportTitleInEditMode(true)} className="re-anchor" /></Box>
                                            <Box className="re-edit-header-subtitle">Description about the report.</Box>
                                        </Box>

                                    </>
                        }
                        
                    </Grid>
                    <Grid container className="re-edit-header-options-container" item  sm={12} md={12} lg={6} order={{ lg: 2, md: 2, sm: 2, xs: 2 }} >
                        <Box className="re-edit-header-options">
                            <Box className="re-edit-header-option re-edit-header-copy-btn">
                                <CopyAsNewIcon /> <span>Copy as new</span>
                            </Box>
                            <Box className="re-edit-header-option re-edit-header-export-btn"  onClick={(e) => handleMoreExportMenuClick(e)}>
                                <ExportIcon /> <span>Export</span> <DropdownIcon />
                            </Box>

                            <Box className="re-edit-header-option re-btn re-btn-outlined"><AddNewReportIcon className="re-btn-icon-left" /> <span>Add New Report</span></Box>
                            <Box className="re-edit-header-option re-btn re-btn-primary"><span>Save Report</span></Box>

                            <Menu
                                id="more-export-menu"
                                MenuListProps={{
                                    'aria-labelledby': 'more-export-button',
                                    //'onMouseLeave': () => setMoreExportMenuEl(null)
                                }}
                                classes={{
                                    root: 'popover-exportmenu-report-header popover-menu'
                                }}
                                PaperProps={{
                                    style: {
                                        minWidth: 110,
                                    },
                                }}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                anchorEl={moreExportMenuEl}
                                open={Boolean(moreExportMenuEl)}
                                onClose={() => setMoreExportMenuEl(null)}
                                TransitionComponent={Fade}
                            >
                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('pdf')}>PDF</MenuItem>
                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('csv')} >CSV file</MenuItem>
                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('excel')} >Excel file</MenuItem>
                            </Menu>
                        </Box>
                        {/* <Grid item xs={12} sm={6} md={6} lg={6} alignItems=""  >
                            <Box >
                                <Grid display="flex" justifyContent="flex-end" className="report-header-menu">
                                    <Grid className="" item lg={4}  >
                                        <div className={classes.headingIcon}>
                                            <Controls.Button className={classes.button + " menu-btn"} text="Add" startIcon={<AddSquareIcon />} variant="text"
                                                id="add-button"
                                                aria-controls="add-menu"
                                                aria-haspopup="true"
                                                aria-expanded={Boolean(addMenuEl) ? 'true' : undefined}
                                                onClick={handleAddMenuHover}
                                            />
                                            <Menu
                                                id="add-menu"
                                                MenuListProps={{
                                                    'aria-labelledby': 'add-button',
                                                    'onMouseLeave': handleAddMenuClose
                                                }}
                                                classes={{
                                                    root: 'popover-menu'
                                                }}
                                                PaperProps={{
                                                    style: {
                                                        minWidth: 150,
                                                    },
                                                }}
                                                anchorEl={addMenuEl}
                                                open={Boolean(addMenuEl)}
                                                onClose={handleAddMenuClose}
                                                TransitionComponent={Fade}
                                            >
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenCalculatedFields(true)}>Add calculated fields</MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenSidebar({ title: 'Settings' })} >Add Title</MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenSidebar({ title: 'Filter' })} >Add Filter</MenuItem>
                                            </Menu>
                                        </div>
                                    </Grid>
                                    <Grid className="" item lg={4} >
                                        <div className={classes.headingIcon}>
                                            <Controls.Button className={classes.button + " menu-btn"} text="More" startIcon={<MoreIcon />} variant="text"
                                                id="more-button"
                                                aria-controls="more-menu"
                                                aria-haspopup="true"
                                                aria-expanded={Boolean(moreMenuEl) ? 'true' : undefined}
                                                onClick={handleMoreMenuHover}
                                            />
                                            <Menu
                                                id="more-menu"
                                                MenuListProps={{
                                                    'aria-labelledby': 'more-button',
                                                    //'onMouseLeave': handleMoreMenuClose
                                                }}
                                                classes={{
                                                    root: 'popover-menu-report-header popover-menu'
                                                }}
                                                PaperProps={{
                                                    style: {
                                                        minWidth: 110,
                                                    },
                                                }}
                                                anchorEl={moreMenuEl}
                                                open={Boolean(moreMenuEl)}
                                                onClose={handleMoreMenuClose}
                                                TransitionComponent={Fade}
                                            >
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleSaveAsPoup('open')}>Copy</MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item popover-menu-item"} onClick={(e) => handleMoreExportMenuClick(e)} >Export <RightAngleIcon className="re-menuitem-more-icon" /></MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleDeleteReportPopup('open')} >Delete</MenuItem>
                                            </Menu>

                                            <Menu
                                                id="more-export-menu"
                                                MenuListProps={{
                                                    'aria-labelledby': 'more-export-button',
                                                    //'onMouseLeave': () => setMoreExportMenuEl(null)
                                                }}
                                                classes={{
                                                    root: 'popover-exportmenu-report-header popover-menu'
                                                }}
                                                PaperProps={{
                                                    style: {
                                                        minWidth: 110,
                                                    },
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                anchorEl={moreExportMenuEl}
                                                open={Boolean(moreExportMenuEl)}
                                                onClose={() => setMoreExportMenuEl(null)}
                                                TransitionComponent={Fade}
                                            >
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('pdf')}>PDF</MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('csv')} >CSV file</MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('excel')} >Excel file</MenuItem>
                                            </Menu>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    </div>
}

export default memo(ReportHeaderNew)